import React, { useState, useEffect } from "react";
// import history from "browser-history";
// import "bootswatch/dist/materia/bootstrap.min.css";
import "./App.scss";

import AppRoutes from "./AppRoutes";
import { pgw } from "./component/api";

const App = (props) => {
  const [options, setOptions] = useState();

  // check enabled payment options
  useEffect(() => {
    const fetch = async () => {
      await pgw
        .get(`/online/settings/Payment Options`)
        .then((res) => setOptions(res.data.data));
    };
    fetch();
  }, []);

  return (
    <div>
      <AppRoutes options={options} />
    </div>
  );
};
export default App;
